export default "__VITE_ASSET__849d4af5__"